// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

import { ENROLLMENT_SUCCESSFUL } from 'actions/enrollmentSuccessful';
import { MY_PAY_WAITLIST_STATUS_RETURNED } from 'actions/myPayWaitlistStatusReturned';
import { PASSWORD_SUBMITTED } from 'actions/passwordSubmitted';
import { PROGRESS_CLEARED } from 'actions/progressCleared';
import { USER_CONNECTED } from 'actions/userConnected';
import { USER_PROGRESSED } from 'actions/userProgressed';

export const initialState = {
  userId: null,
  userProgress: null,
  isPasswordSubmitted: false,
  loginToken: null,
  myPayWaitlist: false,
  userIsConnected: false,
};

/* eslint-disable default-case, no-param-reassign */
const userReducer = (state = initialState, action) =>
  produce(state, draft => {
    const { payload, type } = action;
    switch (type) {
      case PROGRESS_CLEARED:
        return initialState;
      case USER_CONNECTED:
        draft.userId = payload.userId;
        if (payload.referredBy) {
          draft.referredBy = payload.referredBy;
        }
        if (payload.referrerFirstName) {
          draft.referrerFirstName = payload.referrerFirstName;
        }
        draft.userIsConnected = true;
        break;
      case USER_PROGRESSED:
        draft.userProgress = payload.routePath;
        break;
      case PASSWORD_SUBMITTED:
        draft.isPasswordSubmitted = true;
        break;
      case ENROLLMENT_SUCCESSFUL:
        draft.loginToken = payload && payload.loginToken;
        break;
      case MY_PAY_WAITLIST_STATUS_RETURNED:
        draft.myPayWaitlist = payload && payload.myPayWaitlist;
        break;
    }
  });

export default userReducer;
